import React from 'react'

import { RelatorioStatus } from 'common/types'

import { Text } from '@interco/inter-ui/components/Text'
import { IWbAppInfo } from '@interco/inter-webview-bridge'

type CreateRequestDateElementProps = {
  date?: string
  status: RelatorioStatus
  language: IWbAppInfo['language']
}

const lastRequestTextMapper: Record<IWbAppInfo['language'], string> = {
  'pt-BR': 'Última solicitação: ',
  'en-US': 'Last request: ',
  'es-ES': 'Última petición: ',
}

const requestDateTextMapper: Record<IWbAppInfo['language'], string> = {
  'pt-BR': 'Data da solicitação: ',
  'en-US': 'Request date: ',
  'es-ES': 'Fecha de solicitud: ',
}

export const createRequestDateElement = ({
  date,
  status,
  language,
}: CreateRequestDateElementProps) => {
  // sanity check
  if (!date) return <></>

  if (date && status === 'LIBERADA') {
    const lastRequestText = lastRequestTextMapper[language]

    return (
      <Text variant="caption-1" color="typography" colorWeight={400}>
        {lastRequestText}
        {new Intl.DateTimeFormat('pt-BR').format(new Date(date))}
      </Text>
    )
  }

  if (date && status === 'EM_ANALISE') {
    const requestDateText = requestDateTextMapper[language]

    return (
      <Text variant="caption-1" color="typography" colorWeight={400}>
        {requestDateText}
        {new Intl.DateTimeFormat('pt-BR').format(new Date(date))}
      </Text>
    )
  }

  return <></>
}
